import React, { useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Coffee, MapPin, MessageSquare, Heart, ShoppingBag, Sunrise, HandHeart } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
const menuItems = [{
  name: 'About Us',
  href: '/about',
  icon: Heart
}, {
  name: 'Menu',
  href: '/#menu',
  icon: Coffee
}, {
  name: 'Order Online',
  href: '/#order',
  icon: ShoppingBag,
  highlight: true
}, {
  name: 'Our Community',
  href: '/#community',
  icon: MapPin
}, {
  name: 'Feedback',
  href: '/#feedback',
  icon: MessageSquare
}, {
  name: 'Grounded Mornings',
  href: 'https://groundedmornings.com',
  icon: Sunrise,
  external: true
}, {
  name: 'Memory Care Together',
  href: '/memory-care-together',
  icon: HandHeart
}];
export function HamburgerMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const handleNavigation = (href: string, external?: boolean) => {
    setIsOpen(false);
    if (external) {
      window.open(href, '_blank', 'noopener,noreferrer');
    } else if (href.startsWith('/#')) {
      navigate('/');
      // In a real app, you'd handle scrolling to anchor here
    } else {
      navigate(href);
    }
  };
  return <>
      {/* Toggle Button */}
      <button onClick={() => setIsOpen(true)} className="fixed top-6 left-6 z-50 p-3 text-white mix-blend-difference hover:scale-110 transition-transform duration-200" aria-label="Open menu" data-id="element-8">
        <Menu size={32} strokeWidth={1.5} data-id="element-9" />
      </button>

      {/* Full Screen Menu Overlay */}
      <AnimatePresence data-id="element-10">
        {isOpen && <motion.div initial={{
        x: '-100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '-100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed inset-0 z-50 bg-[#1a1a1a] text-white flex flex-col" data-id="element-11">
            {/* Header */}
            <div className="flex justify-between items-center p-6 border-b border-white/10" data-id="element-12">
              <Link to="/" onClick={() => setIsOpen(false)} className="flex items-center gap-3" data-id="element-13">
                <Coffee className="text-[#D97E3A]" size={28} data-id="element-14" />
                <span className="font-bebas text-2xl tracking-wide" data-id="element-15">
                  GROUNDED LIVERMORE
                </span>
              </Link>
              <button onClick={() => setIsOpen(false)} className="p-2 hover:text-[#D97E3A] transition-colors" aria-label="Close menu" data-id="element-16">
                <X size={32} strokeWidth={1.5} data-id="element-17" />
              </button>
            </div>

            {/* Menu Items */}
            <nav className="flex-1 flex flex-col justify-center px-8 md:px-16 space-y-6" data-id="element-18">
              {menuItems.map((item, index) => <motion.button key={item.name} onClick={() => handleNavigation(item.href, item.external)} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: index * 0.1 + 0.2
          }} className={`group flex items-center gap-4 text-4xl md:text-6xl font-bebas tracking-wide transition-colors text-left w-full ${item.highlight ? 'text-[#D97E3A]' : 'text-white hover:text-[#D97E3A]'}`} data-id="element-19">
                  <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 -ml-8 md:-ml-12" data-id="element-20">
                    <item.icon size={24} data-id="element-21" />
                  </span>
                  {item.name}
                </motion.button>)}
            </nav>

            {/* Footer Info */}
            <div className="p-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-white/60 font-inter text-sm" data-id="element-22">
              <p data-id="element-23">A neighborhood coffee shop, by neighborhood folks.</p>
              <div className="flex gap-6" data-id="element-24">
                <a href="#" className="hover:text-white transition-colors" data-id="element-25">
                  Instagram
                </a>
                <a href="#" className="hover:text-white transition-colors" data-id="element-26">
                  Facebook
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}